export default "__VITE_ASSET__Dc7Bcg0z__"